const getDropdownStyles = () => ({
  container: {
    width: '100%',
  },
  control: {
    border: 'none',
    borderRadius: '4px',
    width: '100%',
    boxShadow: 'none',
    padding: '0px',
    height: '28px',
  },
  valueContainer: {
    padding: '0',
    lineHeight: '28px',
    display: 'flex',
    justifyContent: 'center',
  },
  singleValue: {
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '0.8rem',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    whiteSpace: 'nowrap',
    '@media (minWidth: 375px)': {
      fontSize: '.9rem',
    },
  },
  menu: {
    width: '9rem',
  },
  option: {
    fontSize: '0.8rem',
    '@media (minWidth: 375px)': {
      fontSize: '.9rem',
    },
  },
});

export default getDropdownStyles;
